import { render } from "./HeadlineComponent.vue?vue&type=template&id=0a94dcb5&scoped=true"
import script from "./HeadlineComponent.vue?vue&type=script&lang=js"
export * from "./HeadlineComponent.vue?vue&type=script&lang=js"

import "./HeadlineComponent.vue?vue&type=style&index=0&id=0a94dcb5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a94dcb5"]])

export default __exports__